import script from "./AuthWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthWrap.vue?vue&type=script&setup=true&lang=js"

import "./AuthWrap.vue?vue&type=style&index=0&id=64c33857&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c33857"]])

export default __exports__